export const CREATE_PRODUCT_WARRANTY_CLAIMS = 'CREATE_PRODUCT_WARRANTY_CLAIMS'
export const CREATE_PRODUCT_WARRANTY_CLAIMS_SUCCESS = 'CREATE_PRODUCT_WARRANTY_CLAIMS_SUCCESS'
export const CREATE_PRODUCT_WARRANTY_CLAIMS_FAILED = 'CREATE_PRODUCT_WARRANTY_CLAIMS_FAILED'

export const UPDATE_PRODUCT_WARRANTY_CLAIM = 'UPDATE_PRODUCT_WARRANTY_CLAIM'
export const RESET_PRODUCT_WARRANTY_CLAIM = 'RESET_PRODUCT_WARRANTY_CLAIM'
